const RAZORPAY_SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let scriptPromise = null;

// Loads the Razorpay checkout SDK at most once per session.
export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve();

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = RAZORPAY_SCRIPT_SRC;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        scriptPromise = null; // allow a retry on the next attempt
        script.remove();
        reject(new Error("Failed to load Razorpay checkout."));
      };
      document.body.appendChild(script);
    });
  }

  return scriptPromise;
}

// `amount` is passed through untouched - the backend already returns it in paise.
export async function openRazorpayCheckout({
  key,
  order_id,
  amount,
  currency = "INR",
  name = "Webnyay",
  description,
  prefill = {},
  notes,
  onSuccess,
  onFailure,
  onDismiss,
}) {
  await loadRazorpayScript();

  const rzp = new window.Razorpay({
    key,
    order_id,
    amount,
    currency,
    name,
    description,
    prefill,
    notes,
    handler: onSuccess,
    modal: {
      ondismiss: onDismiss,
    },
  });

  if (onFailure) rzp.on("payment.failed", onFailure);

  rzp.open();
  return rzp;
}
